"use client"

import { useState, useEffect } from "react"
import { jwtDecode } from "jwt-decode"
import { Btn, FeatherIcons, LI, UL } from "../../../../AbstractElements"
import { Link, useNavigate } from "react-router-dom"
import { LogOut } from "../../../../utils/Constant"

interface DecodedToken {
  is_superuser: boolean
  email: string
  person?: {
    first_name: string
    last_name: string
  }
}

type FeatherIconName = "User" | "Settings"

interface ProfileMessage {
  name: string
  icon: FeatherIconName
  link: string
}

const ProfileBox = () => {
  const navigate = useNavigate()
  const [profilesMessage, setProfilesMessage] = useState<ProfileMessage[]>([])

  useEffect(() => {
    let displayName = "Guest"

    try {
      const token = localStorage.getItem("accessToken")
      if (token) {
        const decoded: DecodedToken = jwtDecode(token)
        displayName = decoded.is_superuser ? "Super": decoded.person?.first_name || "User"
      }
    } catch (error) {
      console.warn("Failed to decode token for profile display", error)
    }

    setProfilesMessage([
      {
        name: displayName,
        icon: "User",
        link: `${process.env.PUBLIC_URL}/users/useredit`,
      },
      {
        name: "Settings",
        icon: "Settings",
        link: `${process.env.PUBLIC_URL}/users/useredit`,
      },
    ])
  }, [])

  const handleClick = () => {
    localStorage.removeItem("accessToken")
    navigate(`${process.env.PUBLIC_URL}/auth/login/`)
  }

  return (
    <UL className="profile-dropdown onhover-show-div">
      {profilesMessage.map((data, index) => (
        <LI key={index}>
          <Link to={data.link}>
            <FeatherIcons iconName={data.icon} />
            <span>{data.name}</span>
          </Link>
        </LI>
      ))}
      <LI>
        <Btn size="sm" outline color="primary" className="btn-pill" onClick={handleClick}>
          {LogOut}
        </Btn>
      </LI>
    </UL>
  )
}

export default ProfileBox
